/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleCreateResponse {
    getFixupPrototypeFunction() { return RoleCreateResponse.fixupPrototype; }

    static newInstance(model: Partial<RoleCreateResponse>): RoleCreateResponse {
        let obj = Object.assign(new RoleCreateResponse(), model);
        RoleCreateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleCreateResponse>): RoleCreateResponse {
        if (!model) return null;
        return RoleCreateResponse.newInstance(<RoleCreateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleCreateResponse) {
        if (!obj) return;

        models.RoleCreateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleCreateResponse): boolean {
        Object.setPrototypeOf(obj, RoleCreateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the newly created role
     */
    id: string;

}
